export const RADIATION_ID = 8;
export const ENTRY_BY_INTRUDERS_ID = 12;

export const UNSUPPORTED_HAZARD_IDS = [];
